<template>
	<div class="w-[50vw] h-[80vh] bg-white px-[40px] pt-[4%] box-border top-[50%] left-[50%] absolute"
		style="transform: translate(-50%,-50%);">
		<div class="text-[20px] font-bold text-[#1B2128] mb-[29px]">
			{{langInfo.study_report}}
		</div>
		<div class="text-[20px] font-bold text-[#1B2128] mb-[30px]">
			<!-- 章节练习 -->
			<label v-if="type=='sele'">{{langInfo.study_report_title}} </label>
			<label v-else-if="type=='userwrong'">{{langInfo.study_wrong_report_title}}</label>
			<label v-else-if="type=='collect'">{{langInfo.study_collect_report_title}}</label>
		</div>
		<div class=" mb-[25px]">
			<div class="mb-[10px]">
				<label class="text-[24px]  text-[#FF0000]">{{info.zql}} </label>
				<label class="text-[16px]">{{langInfo.study_paper_count}}，{{langInfo.study_report_percent}}</label>
				<label class="text-[24px]  text-[#FF0000]"> {{info.accuracy}}</label>
			</div>
			<div class="text-[16px]">
				{{langInfo.study_report_total}} {{info.count}} {{langInfo.study_paper_count}}!
			</div>
		</div>
		<div class="mb-[30px] text-[16px]">
			{{langInfo.study_paper_result_select}}: <label class="font-bold text-[#FF0000]">{{info.zql}}
			</label>{{langInfo.study_paper_count}},
			{{langInfo.study_report_percent}}  <label class="font-bold text-[#FF0000]">{{info.accuracy}}
			</label>({{langInfo.study_exercise_total}}:
			{{info.count}} {{langInfo.study_paper_count}})
		</div>
		<div class="text-[12px] text-[#FF0000] leading-[25px] mb-[21px]">
			{{langInfo.study_report_time}}：{{info.end_time}}
		</div>

		<div @click="goExamAnalysisClick()" v-if="isFinish"
			class="w-[200px] h-[40px] cursor-pointer leading-[40px] mx-auto rounded-[6px] text-center text-white text-[16px] bg-[#68C340]">
			{{langInfo.study_paper_result_answer}}
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				id: '',
				info: {
					count: '',
					zql: '',
					accuracy: '',
				},
				type: "", //sele章节练习  userwrong错题练习  collect收藏练习
				langInfo: {},
				order_item_id: '',
				isFinish: false

			}
		},
		mounted() {
			this.id = this.$route.query.id
			this.type = this.$route.query.type
			this.order_item_id = this.$route.query.order_item_id


			this.getdict_data()

			this.getQuestionPapercomplete()

		},
		methods: {
			getdict_data() {
				this.$api.dict_data({}).then((res) => {
					console.log(res);
					const obj = {}
					res.data.forEach((item, index) => {
						obj[item.key] = item.value
					})
					this.langInfo = obj


					document.title = this.langInfo.study_report



					this.$store.dispatch('lang/setLangList', obj)
				}).catch((error) => {})
			},
			getQuestionPapercomplete() {
				this.$api.getQuestionPapercomplete({
					id: this.id
				}).then((res) => {
					console.log(res);
					this.info = res.data
					this.isFinish = true

				}).catch((error) => {
					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})
			},
			goExamAnalysisClick() {
				this.$router.push({
					path: '/exam/chapterAnalysis',
					query: {
						type: this.type,
						identification: this.info.identification,
						small_id: this.info.course_chapter_small_id,
						order_item_id: this.order_item_id
					}
				})
			}

		}
	}
</script>

<style scoped>
	/deep/p img {
		width: 100% !important;
	}
</style>